import { type ReactElement } from 'react'
import { Text } from '@mantine/core'
import { useTranslation } from '@front/model'
import { PERM_GRAPH_LABEL_BACKGROUND, PERM_GRAPH_LABEL_COLOR, PERM_GRAPH_WINNER_LABEL } from './permGraphVisualState'

export function PermGraphWinnerLabel(): ReactElement {
  const { t } = useTranslation()

  return (
    <Text
      className='left-2xl px-sm py-xs pointer-events-none absolute top-0 z-10 -translate-y-1/2 rounded-md font-semibold whitespace-nowrap'
      data-perm-graph-winner-label
      size='xs'
      style={{ background: PERM_GRAPH_LABEL_BACKGROUND, color: PERM_GRAPH_LABEL_COLOR }}
    >
      {t(PERM_GRAPH_WINNER_LABEL)}
    </Text>
  )
}
